import template from 'text!./coverage-term.html';

export default [function () {
    return {
        restrict: 'E',
        template: template,
        scope: {
            term: '=',
            updating: '=',
            isMultipleOffering: '&',
            valueTypeAma: '=',
            hidePlaceholderOption: '=?'
        },
        controller: ['$scope', 'LocaleService', function ($scope, LocaleService) {

            var term = $scope.term;

            $scope.currencySymbolAma = LocaleService.getLocaleInfo().currency.symbol;
            $scope.isMoneyAma = $scope.valueTypeAma === 'Money';
            $scope.typeIsSelect = term.hasOptions && term.valueType !== 'bit';
            $scope.typeIsBinary = term.hasOptions && term.valueType === 'bit';
            $scope.typeIsDateTime = !term.hasOptions && term.valueType === 'datetime';
            $scope.typeIsTextArea = !term.hasOptions && term.valueType === 'shorttext';
            $scope.typeIsOrdinaryInput = !term.hasOptions && term.valueType !== 'datetime' && term.valueType !== 'shorttext' && term.valueType !== 'bit';
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/coverageterm/CoverageTerm.js
// module id = 796
// module chunks = 0